export default "__VITE_ASSET__NMBjNvBA__"